import { inject, Injectable } from '@angular/core';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private loadingCount = 0;
  private ngxService = inject(NgxUiLoaderService);
  showLoader(): void {
    this.loadingCount++;
    if (this.loadingCount > 0) {
      this.ngxService.start();
    }
  }

  hideLoader(): void {
    if (this.loadingCount === 0) return;
    this.loadingCount--;
    if (this.loadingCount === 0) {
      this.ngxService.stop();
    }
  }
}
